import { ChangeDetectorRef, Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ItemService } from '@services/item.service';
import { NotificationService } from '@services/notification.service';
import { RoleManagementService } from '@services/role.management.service';
import { WebErrorService } from '@services/webError.service';
import { EMPTY, Subject, Subscription } from 'rxjs';
import { debounceTime, finalize, startWith, switchMap, tap } from 'rxjs/operators';
import { DelMessageComponent } from 'src/app/shared/del-message/del-message.component';
import { filter, takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-item-tags',
  templateUrl: './item-tags.component.html',
  styleUrls: ['./item-tags.component.scss'],
})
export class ItemTagsComponent implements OnDestroy {
  itemUUID: any;
  collectionUUID: any;
  displayedColumns: string[] = ['tagtypename', 'tagdescription', 'itemTagId'];


  tagsForTable: any[] = [];

  itemId: any;
  tags = new MatTableDataSource<any>([]);
  filteredtags: any[] = [];
  tagsForm: FormGroup;
  isLoading = false;
  isNoTags = false;
  tagTableDataSource: any;
  flatTags: any[] = [];
  flatTagsforTable: any[] = [];
  collectionId: any;
  @Input() isPublished;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  private itemTagsSubscription: Subscription;
  routeSubscription: Subscription;
  showPaginator : any;
  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(private itemService: ItemService,
    private router: Router,
    private routerstate: ActivatedRoute,
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private cdr: ChangeDetectorRef,
    public roleSer: RoleManagementService,
    private webErrorService: WebErrorService,
    private translate: TranslateService
  ) {
    this.tagsForm = this.fb.group({
      userInput: null
    });
    this.roleSer.getPermissionForTags(this.roleSer.accessData);
    this.itemService.updateStatus.subscribe(
      statusdata => {
        statusdata == 1 ? this.isPublished = true : this.isPublished = false;
      });
  }

  @Input() set item(data) {
    if (data) {
      this.itemUUID = data.data.itemuuId
      this.collectionUUID = JSON.parse(sessionStorage.defaultcollectionuuid);
      this.getItemTags();
     this.getSerachedTags();
    }
  }

  getSerachedTags(){
    if(this.roleSer.accessData && this.roleSer.accessData.insertAllowed || this.roleSer.accessData.updateAllowed){
      this.tagsForm.get('userInput')!.valueChanges.pipe(
        debounceTime(100)).subscribe(d => {
          this.isLoading = true
          this.itemService.getAllTagsForItem(this.collectionUUID, this.itemUUID, d).subscribe(tags => {
            this.isLoading = false
            this.filteredtags = tags?.data;
            this.flatTags = [];
            this.filteredtags.forEach(t => {
              t?.tags?.forEach((element: any) => {
                let a = {
                  ...element,
                  tagtypename: t.tagtypename
                }
                this.flatTags.push(a);
              });
            });
            this.tagsForm.get('userInput')?.valueChanges.subscribe(data => {
              if (data.length == 0) {
                this.flatTags = [];
              }
            });
          })
        })

      // this.tagsForm.get('userInput')!.valueChanges.pipe(
      //   debounceTime(100),
      //   startWith(''),
      //   tap(() => this.isLoading = true),
      //   switchMap(value => value?.length > 1 ? this.itemService.getAllTagsForItem(this.collectionUUID, this.itemUUID, value) : EMPTY
      //     .pipe(finalize(() => this.isLoading = false))
      //   )
      // ).subscribe(tags => {
      //   this.isLoading = false
      //   this.filteredtags = tags?.data;
      //   this.flatTags = [];
      //   this.filteredtags.forEach(t => {
      //     t?.tags?.forEach((element: any) => {
      //       let a = {
      //         ...element,
      //         tagtypename: t.tagtypename
      //       }
      //       this.flatTags.push(a);
      //     });
      //   });
      //   this.tagsForm.get('userInput')?.valueChanges.subscribe(data => {
      //     if (data.length == 0) {
      //       this.flatTags = [];
      //     }
      //   });
      // });
    };
  }

  getItemTags() {
    this.itemTagsSubscription = this.itemService.getTags(this.itemUUID).subscribe(
      resData => {
        this.tagsForTable = resData?.data;
        this.tagTableDataSource = resData?.data;
        if (this.tagTableDataSource?.length === 0) {
          this.isNoTags = true;
        }
        else {
          this.tagTableDataSource = new MatTableDataSource(this.tagTableDataSource);
          this.showPaginator = this.tagTableDataSource.filteredData.length;
          this.tagTableDataSource.sort = this.sort;
          setTimeout(() => {
            this.tagTableDataSource.paginator = this.paginator;

            if(this.tagTableDataSource.paginator) {
              // ------Set translation for pagination------
              this.translate.stream([
                'itemDetails.TabTags.pagination.pageLabel',
                'itemDetails.TabTags.pagination.firstPage',
                'itemDetails.TabTags.pagination.lastPage',
                'itemDetails.TabTags.pagination.nextPage',
                'itemDetails.TabTags.pagination.prevPage'
              ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
                  this.tagTableDataSource.paginator._intl.itemsPerPageLabel = translation['itemDetails.TabTags.pagination.pageLabel'];
                  this.tagTableDataSource.paginator._intl.firstPageLabel = translation['itemDetails.TabTags.pagination.firstPage'];
                  this.tagTableDataSource.paginator._intl.lastPageLabel = translation['itemDetails.TabTags.pagination.lastPage'];
                  this.tagTableDataSource.paginator._intl.nextPageLabel = translation['itemDetails.TabTags.pagination.nextPage'];
                  this.tagTableDataSource.paginator._intl.previousPageLabel = translation['itemDetails.TabTags.pagination.prevPage'];

                  this.tagTableDataSource.paginator._intl.changes.next();
              });
            }
          });


          this.isNoTags = false;
        }

        this.flatTagsforTable = [];
        this.tagsForTable.forEach(t => {
          t?.tags.forEach((element: any) => {
            let a = {
              ...element,
              tagtypename: t.tagtypename
            }
            this.flatTagsforTable.push(a);
          });
          this.tagTableDataSource = this.flatTagsforTable;
          this.tags.data = this.flatTagsforTable;
          this.tags.sort = this.sort;
          this.tags.paginator = this.paginator;
        });
      }, (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });
  }

  addTagtoItem(data: any) {
    this.itemService.addTag(this.itemUUID, data.taguuId, 0).subscribe(
      (resdata) => {
        this.isNoTags = false;
        this.notificationService.success(resdata?.message); // THis line used to display message
        this.itemService.getTags(this.itemUUID).subscribe(
          resData => {
            if(resData){
              this.getItemTags()
            }
          }, (error: any) => {
            this.webErrorService.handleAPIErrors(error, null, true, 'warn');
          });
          this.tagsForm.get('userInput')?.setValue("");
      }
      , (error: any) => {
        this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        this.tagsForm.get('userInput')?.setValue("");
      });
  }

  displayFn(tags: any): string {
    let seprator: string = "-";
    if (tags) {
      return tags.tagtypename + seprator + tags.tagName;
    }
    return '';
  }

  deleteItemTag(itemTagId: any) {
    const dialogRef = this.dialog.open(DelMessageComponent, {
      data: {
        message: this.translate.instant('itemDetails.TabTags.deletePopup.message'),
        buttonText: {
          ok: this.translate.instant('itemDetails.TabTags.deletePopup.btnYes'),
          cancel: this.translate.instant('itemDetails.TabTags.deletePopup.btnNo')
        }
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.itemService.deleteTagOfItem(itemTagId, this.itemUUID).subscribe(data => {
          this.itemService.getTags(this.itemUUID).subscribe(
            resData => {
              this.flatTagsforTable = [];
              if (resData?.data.length == 0) {
                this.tags.data = this.flatTagsforTable;
                this.isNoTags = true;
              }
              // this.getItemTags()
              resData?.data.forEach((t: any) => {
                t?.tags.forEach((element: any) => {
                  let a = {
                    ...element,
                    tagtypename: t.tagtypename
                  }
                  this.flatTagsforTable.push(a);
                });
                this.tags.data = this.flatTagsforTable;
                this.tagTableDataSource = this.flatTagsforTable;
              })
            }
            , (error: any) => {
              this.webErrorService.handleAPIErrors(error);
            });
          this.notificationService.success(data?.message);
        }, (error: any) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        });
      }
      this.routerstate.paramMap.pipe(
        switchMap((params: any) => {
          this.itemId = params.get('id');
          this.collectionId = sessionStorage.getItem('defaultcollectionid');
          return this.itemService.getTags(this.itemId)
        }
        )).subscribe(
          resData => {
            this.tagsForTable = resData?.data;
            this.flatTagsforTable = [];
            this.tagsForTable.forEach(t => {
              t?.tags.forEach((element: any) => {
                let a = {
                  ...element,
                  tagtypename: t.tagtypename
                }
                this.flatTagsforTable.push(a);
              });
              this.tags.data = this.flatTagsforTable;
            })
          }
        )
    });
  }

  ngOnDestroy(): void {
    if (this.itemTagsSubscription) { this.itemTagsSubscription.unsubscribe(); }
  }
}
